<div class="modal-content text-center">
  <div class="modal-header">
    <h4 class="modal-title">
      <ng-template [ngIf]="!editGuest">Neuen Gast anlegen</ng-template>
      <ng-template [ngIf]="editGuest">Gastdaten ändern</ng-template>
    </h4>
    <button aria-label="Close" class="close" (click)="activeModal.dismiss()" type="button">
      <span class="fas fa-times"></span>
    </button>
  </div>
  <div class="onboarding-content">
    <form [formGroup]="guestFormGroup">
      <div class="row">
        <div class="col-md-3 form-group">
          <label for="form">Anrede</label>
          <ng-select
            [items]="arrayOfPrefixes"
            [clearable]="false"
            [searchable]="false"
            formControlName="form"
            bindLabel="form"
            bindValue="form"
          >
          </ng-select>
        </div>
        <div class="col-md-9 form-group">
          <label>Firmenname</label>
          <input class="form-control" formControlName="company" type="text" />
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="name">
              Name
            </label>
            <input class="form-control" name="name" formControlName="name" type="text" value="" />
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label *ngIf="guestFormGroup.value.form !== 'Firma'">Vorname</label>
            <label *ngIf="guestFormGroup.value.form === 'Firma'">Firmenname</label>
            <input class="form-control" name="firstName" formControlName="firstName" type="text" value="" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="email">
              Email
            </label>
            <input class="form-control" name="email" formControlName="email" type="text" value="" />
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label for="phone">
              Telefonnummer
            </label>
            <input class="form-control" name="phone" formControlName="phone" type="text" value="" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label for="address">
              Straße
            </label>
            <input class="form-control" name="address" formControlName="address" type="text" value="" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="zip">
              PLZ
            </label>
            <input class="form-control" name="zip" formControlName="zip" type="text" value="" />
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label for="place">
              Ort
            </label>
            <input class="form-control" name="place" formControlName="place" type="text" value="" />
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="form-group">
          <label for="birthdate">Geburtstag</label>
          <div class="input-group">
            <div class="input-group-prepend" (click)="birthdayDatePicker.open()">
              <div class="input-group-text">
                <i class="fas fa-calendar-alt"></i>
              </div>
            </div>
            <mat-datepicker #birthdayDatePicker (closed)="dateFromInput1.blur()"></mat-datepicker>
            <input
              class="form-control"
              #dateFromInput1
              formControlName="birthdate"
              placeholder="Geburtsdatum auswählen"
              type="text"
              name="birthdate"
              [matDatepicker]="birthdayDatePicker"
              (focus)="birthdayDatePicker.open()"
            />
            <div
              *ngIf="guestFormGroup.get('birthdate').value"
              class="input-group-append"
              style="cursor: pointer;"
              (click)="guestFormGroup.get('birthdate').setValue(null)"
            >
              <div class="input-group-text">
                <i class="fas fa-times"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-12">
        <div class="form-group">
          <label for="weddingDay">Hochzeitstag</label>
          <div class="input-group">
            <div class="input-group-prepend" (click)="weddingDatePicker.open()">
              <div class="input-group-text">
                <i class="fas fa-calendar-alt"></i>
              </div>
            </div>
            <mat-datepicker #weddingDatePicker (closed)="dateFromInput2.blur()"></mat-datepicker>
            <input
              class="form-control"
              #dateFromInput2
              formControlName="weddingDay"
              placeholder="Hochzeitsdatum auswählen"
              type="text"
              name="weddingDay"
              [matDatepicker]="weddingDatePicker"
              (focus)="weddingDatePicker.open()"
            />
            <div
              *ngIf="guestFormGroup.get('weddingDay').value"
              class="input-group-append"
              style="cursor: pointer;"
              (click)="guestFormGroup.get('weddingDay').setValue(null)"
            >
              <div class="input-group-text">
                <i class="fas fa-times"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="editGuest" class="row">
        <div class="col-sm-4">
          <div class="form-group">
            <label for="lastVisit">
              Letzter Besuch
            </label>
            <div class="row" name="lastVisit">
              <div class="col-sm-12">{{ editGuest.lastVisit | date }}</div>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label for="visits">
              Anzahl Besuche
            </label>
            <div class="row" name="visits">
              <div class="col-sm-12">{{ editGuest.visits }}</div>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label for="no-shows">
              Anzahl no Shows
            </label>
            <div class="row" name="no-shows">
              <div class="col-sm-12">{{ editGuest.noShow }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label for="intolerance">
              Unverträglichkeiten
            </label>
            <div style="border: 1px solid #dee2e6; border-radius: 8px; padding: 16px; background: #fff;">
              <div *ngFor="let group of incompatibilitiesGrouped" class="mb-3">
                <div
                  class="text-muted font-weight-bold mb-2"
                  style="font-size: 11px; letter-spacing: 0.08em; text-transform: uppercase;"
                >
                  {{ 'HotelReservations.DietaryType.' + group.key | translate }}
                </div>
                <div class="d-flex flex-wrap" style="gap: 6px;">
                  <span
                    *ngFor="let code of group.value"
                    (click)="toggleCode(group.key, code)"
                    style="display:inline-block; cursor:pointer; border-radius:20px; padding:5px 14px; font-size:13px; margin:2px; user-select:none; transition: all 0.15s;"
                    [style.background]="isCodeSelected(code) ? '#4a9fd5' : '#fff'"
                    [style.color]="isCodeSelected(code) ? '#fff' : '#333'"
                    [style.border]="isCodeSelected(code) ? '1px solid #4a9fd5' : '1px solid #ccc'"
                    >{{ 'HotelReservations.DietaryCode.' + code | translate }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label for="notes">
              Zusätzliche Hinweise
            </label>
            <textarea class="form-control" name="notes" formControlName="notes" type="text" value=""></textarea>
          </div>
        </div>
      </div>
      <div class="row">
        <button class="btn btn-primary btn-block btn-lg" (click)="createGuest()" *ngIf="!editGuest">
          Gast anlegen
        </button>
        <button class="btn btn-primary btn-block btn-lg" (click)="updateGuest()" *ngIf="editGuest">
          Gast speichern
        </button>
        <button
          *ngIf="editGuest"
          type="button"
          class="btn btn-link mt-3"
          style="color: red;"
          (click)="deleteGuest(guestFormGroup.value)"
        >
          Gast löschen <i class="fas fa-trash-alt"></i>
        </button>
      </div>
    </form>
  </div>
</div>
